<script>
export default {
  props: {
    position: {
      type: String,
      default: 'is-top-left',
    },
    items: {
      type: Array,
      required: true,
    },
    isSection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasExpertPlan() {
      return this.$store.getters['auth/hasExpertPlan'];
    },
    isNotPercentPlan() {
      return this.$store.getters['auth/isNotPercentPlan'];
    },
  },
  methods: {
    addLesson() {
      this.$emit('add-lesson');
    },
    addChapter() {
      this.$emit('add-chapter');
    },
    addQuiz() {
      this.$emit('add-quiz');
    },
    addTasks() {
      if (!this.isNotPercentPlan) {
        this.$showMessage.goPro();
        return;
      }
      this.$emit('add-tasks');
    },
    addAssignment() {
      if (!this.isNotPercentPlan) {
        this.$showMessage.goPro();
        return;
      }
      this.$emit('add-assignment');
    },
  },
};
</script>

<template>
  <b-dropdown aria-role="list" :position="position" append-to-body>
    <template #trigger>
      <b-button class="m" type="is-primary" icon-right="plus-circle">
        <template v-if="items.length === 0">
          Ajouter un contenu pédagogique
        </template>
        <template v-else-if="isSection">
          Ajouter au chapitre
        </template>
        <template v-else>
          Ajouter
        </template>
      </b-button>
    </template>

    <b-dropdown-item aria-role="listitem" @click="addLesson()">
      <div>
        <div class="is-flex is-align-items-center mb-1">
          <span class="is-size-7 has-text-weight-semibold mr-2">Leçon</span>
          <b-icon icon="book-open-page-variant" size="is-small" class="has-text-grey" />
        </div>
        <div class="is-size-7">
          Transmettre un contenu pédagogique
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item v-if="$listeners['add-chapter']" aria-role="listitem" @click="addChapter()">
      <div>
        <div class="is-flex is-align-items-center mb-1">
          <span class="is-size-7 has-text-weight-semibold mr-2">Chapitre</span>
          <b-icon icon="folder" size="is-small" class="has-text-grey" />
        </div>
        <div class="is-size-7">
          Organiser les leçons
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" @click="addQuiz()">
      <div>
        <div class="is-flex is-align-items-center mb-1">
          <span class="is-size-7 has-text-weight-semibold mr-2">Quiz</span>
          <b-icon icon="help-circle" size="is-small" class="has-text-grey" />
        </div>
        <div class="is-size-7">
          Évaluer les acquis
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" @click="addTasks()">
      <div>
        <div class="is-flex is-align-items-center mb-1">
          <span class="is-size-7 has-text-weight-semibold mr-2">Tâches & missions</span>
          <b-icon icon="checkbox-marked-circle-outline" size="is-small" class="has-text-grey" />
          <AppFeatureBadge v-if="!isNotPercentPlan" class="ml-2" />
        </div>
        <div class="is-size-7">
          Guider la mise en pratique
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" @click="addAssignment()">
      <div>
        <div class="is-flex is-align-items-center mb-1">
          <span class="is-size-7 has-text-weight-semibold mr-2">Devoir</span>
          <b-icon icon="file-document-edit" size="is-small" class="has-text-grey" />
          <AppFeatureBadge v-if="!isNotPercentPlan" class="ml-2" />
        </div>
        <div class="is-size-7">
          Demander un travail à rendre
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>
